import { getDispatcherUrl } from 'modules/utils/UrlUtils';
import { DispatcherAuthPrefix, DispatcherCategoryService } from 'modules/types/common';
import Config from 'react-native-config';
import { AddressComponent, FieldValue, GeoCodeLocation } from './types';
import { ENDPOINT_NAMES, IS_SERVICE_EXPANSION_ENABLED, LOCATION_URLS } from './constant';

interface GetLocationCallData {
  endpointName: ENDPOINT_NAMES;
  data: Object;
  params?: Object;
}

function getStringParams(params: Object) {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    searchParams.append(key, value);
  });

  return searchParams.toString();
}

export function getLocationCallData(locationData: GetLocationCallData) {
  const headers = IS_SERVICE_EXPANSION_ENABLED ? { 'mhp-adapter': 'mhp' } : {};

  const paramsFormat = getStringParams({
    ...locationData.data,
    ...(locationData.params ? locationData.params : {})
  });

  if (!IS_SERVICE_EXPANSION_ENABLED) {
    return {
      headers,
      url: `${Config.LOCATION_BASE_URL}${LOCATION_URLS[locationData.endpointName]}${
        paramsFormat.length ? `?${paramsFormat}` : ''
      }`
    };
  }

  const url = `${getDispatcherUrl(
    DispatcherCategoryService.UTILITY,
    DispatcherAuthPrefix.PUBLIC,
    '',
    LOCATION_URLS[locationData.endpointName],
    true
  )}${paramsFormat.length ? `?${paramsFormat}` : ''}`;

  return {
    headers,
    url
  };
}

export const addressFromComponents = (addressComponents: AddressComponent[]) => {
  const streetAddress = {
    number: '',
    street: ''
  };

  const newAC: FieldValue[] = [];

  addressComponents.forEach(function addressFromAC(ac: AddressComponent) {
    switch (ac.types[0]) {
      case 'street_number':
        streetAddress.number = ac.long_name;
        break;
      case 'route':
        streetAddress.street = ac.long_name;
        break;
      case 'locality':
        newAC.push({ name: 'city', value: ac.long_name });
        break;
      case 'administrative_area_level_1':
        newAC.push({ name: 'state', value: ac.short_name });
        break;
      case 'country':
        newAC.push({ name: 'country', value: ac.long_name });
        break;
      case 'postal_code':
        newAC.push({ name: 'postalCode', value: ac.long_name });
        break;
      default:
    }
  });

  newAC.push({ name: 'streetAddress', value: `${streetAddress.number} ${streetAddress.street}` });

  return newAC;
};

export function getGeolocationPostalCode(geolocation?: GeoCodeLocation) {
  if (!geolocation) return '';
  const components = geolocation.address_components;
  const geolocationPostalCode = components.find(({ types }) => {
    return types[0] === 'postal_code';
  });
  return geolocationPostalCode ? geolocationPostalCode.short_name : '';
}
